if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.checkCart.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.onePerCustomer = this.dataset.one == "true";
      this.handle = this.dataset.handle;
      this.advice = document.querySelector(".one-per-customer");
      this.proxyAddToCart = this.querySelector('[data-add-to-cart-proxy]');
      this.productInfo = document.querySelector('.product__info-container');
      this.proxyAddToCartLink = this.proxyAddToCart ? this.proxyAddToCart.querySelector('[data-add-to-cart-proxy-link]') : null;
      this.footer = document.querySelector('footer.footer');
      if(this.proxyAddToCart && this.proxyAddToCartLink) {
        document.addEventListener("scroll", this.activateProxyOnScroll.bind(this));
        this.proxyAddToCart.addEventListener('click', this.onProxyClick.bind(this));
        /* #920: il proxy fisso rispecchia il pulsante d'acquisto VISIBILE
           (etichetta e stato): il bottone vero, oppure «Avvisami» (#notify_button)
           che l'app Back in Stock inserisce al suo posto sulle varianti esaurite.
           Si osserva il contenitore dei pulsanti: cambio variante, inserimento
           e visibilità del pulsante dell'app. */
        this.syncProxy();
        var buttons = this.submitButton && this.submitButton.parentElement;
        if (buttons) {
          new MutationObserver(this.syncProxy.bind(this)).observe(buttons, {
            attributes: true, attributeFilter: ['disabled', 'class', 'style', 'hidden'], childList: true, subtree: true, characterData: true
          });
        }
      }

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      if(this.onePerCustomer) this.handleButton();
    }

    checkCart(evt){
      evt.preventDefault();
      let found = false;
      // #957: cart.js dalla cartella del mercato (Shopify.routes.root), mai dalla root IT
      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js')
      .then((response) => response.json())
      .then((data) => {
        for(const item of data.items){
          if(item.handle == this.handle){
            console.log("found item in cart")
            found = true;
          }
        }
        this.canAdd(found)
      });
    }

    canAdd(is_in_cart){
      if(this.onePerCustomer){
        // console.log(is_in_cart);
        if(is_in_cart){
          console.log("non aggiunto");
          this.submitButton.setAttribute('disabled', 'disabled');
          this.advice.classList.add("highlight");
        }
        else{
          console.log("add")
          this.onSubmitHandler();
        }
      }
      else{
        console.log("add");
        this.onSubmitHandler();
      }

    }

    onSubmitHandler() {
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        if(this.onePerCustomer) this.handleButton();
      });

    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || document.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        !this.submitButton.classList.contains("error") ? this.submitButton.classList.add("error") : null;
        this.errorMessage.textContent = errorMessage;
      }
    }

    handleButton(){
      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js')
      .then((response) => response.json())
      .then((data) => {
        for(const item of data.items){
          if(item.handle == this.handle){
            this.submitButton.setAttribute('disabled', 'disabled');
            this.advice.classList.add("highlight");
          }
        }
        this.submitButton.closest('.product-form').classList.remove("hidden");
      });
    }


    visibile(el) {
      return !!el && !el.classList.contains('hidden') && el.style.display !== 'none' && el.getClientRects().length > 0;
    }

    /* Pulsante d'acquisto a schermo: il bottone vero se visibile, altrimenti
       «Avvisami» dell'app (esaurito), altrimenti il bottone vero (disabilitato). */
    ctaVisibile() {
      if (this.visibile(this.submitButton)) return this.submitButton;
      var buttons = this.submitButton && this.submitButton.parentElement;
      var notify = buttons ? buttons.querySelector('#notify_button') : null;
      return this.visibile(notify) ? notify : this.submitButton;
    }

    syncProxy() {
      if (!this.submitButton || !this.proxyAddToCartLink) return;
      var cta = this.ctaVisibile();
      var disabled = cta === this.submitButton && this.submitButton.hasAttribute('disabled');
      if (disabled) this.proxyAddToCartLink.setAttribute('aria-disabled', 'true');
      else this.proxyAddToCartLink.removeAttribute('aria-disabled');
      this.proxyAddToCartLink.dataset.cta = cta === this.submitButton ? 'add' : 'notify';
      var source = cta.querySelector(':scope > span');
      var target = this.proxyAddToCartLink.querySelector(':scope > span');
      var label = source ? source.textContent.trim() : '';
      if (!target || !label) return;
      var icon = target.querySelector('svg');
      if (target.textContent.trim() === label) return;
      target.textContent = label;
      if (icon) target.prepend(icon);
    }

    onProxyClick(evt) {
      evt.preventDefault();
      /* #920: mai un'azione su un prodotto non acquistabile; il proxy non
         aggiunge mai al carrello, porta solo all'area d'acquisto. */
      if (this.proxyAddToCartLink.getAttribute('aria-disabled') === 'true') return;
      var pInfo = this.productInfo || this.form;
      if(pInfo) {
        pInfo.scrollIntoView({ behavior: 'smooth' });
      }
    }

    activateProxyOnScroll(evt) {
      if(!this.submitButton) return;
      /* Il proxy compare solo quando il vero ADD TO BAG è uscito dalla
         viewport verso l'alto: con la colonna info sticky (desktop) il
         bottone resta sempre visibile e il proxy non compare mai. Il
         vecchio calcolo su offsetTop scattava troppo presto e
         sovrapponeva il proxy al bottone reale e alle foto. */
      var buttonBottom = this.ctaVisibile().getBoundingClientRect().bottom;
      var active = buttonBottom < 0;
      this.proxyAddToCart.classList.toggle('active', active);
      /* #920: fuori schermo il proxy non entra nella tabulazione né negli screen reader. */
      this.proxyAddToCart.setAttribute('aria-hidden', active ? 'false' : 'true');
      this.proxyAddToCartLink.tabIndex = active ? 0 : -1;
    }
  });
}
